import React, {useCallback, useState} from 'react';
import type {ColumnSetting} from '../../hooks/useColumnSettings';
import styles from './index.module.less';
import Popover from '@/components/common/Popover';
import Button from '@/components/common/Button';
import Icon from '@/components/common/Icon';

export interface ColumnSettingsProps {
    settings: ColumnSetting[];
    toggleColumn: (key: string) => void;
    toggleAll: (visible: boolean) => void;
    onOpenChange?: (open: boolean) => void;
}

const getPopupContainer = () => document.body;

const ColumnSettings: React.FC<ColumnSettingsProps> = ({
    settings,
    toggleColumn,
    toggleAll,
    onOpenChange,
}) => {
    const [open, setOpen] = useState(false);

    const handleOpenChange = useCallback(
        (val: boolean) => {
            setOpen(val);
            onOpenChange?.(val);
        },
        [onOpenChange],
    );

    const panelContent = (
        <div className={styles.panel}>
            <div className={styles.header}>
                <span className={styles.title}>展示信息</span>
                <Button
                    type="text"
                    size="mini"
                    className={styles.toggleAllBtn}
                    onClick={() => toggleAll(true)}
                >
                    全展示
                </Button>
            </div>
            <ul className={styles.list}>
                {settings.map((col) => (
                    <li
                        key={col.key}
                        className={`${styles.item} ${col.visible ? styles.itemVisible : ''}`}
                        onClick={() => toggleColumn(col.key)}
                    >
                        <span className={styles.colName}>{col.name}</span>
                        <Icon
                            className={styles.eyeIcon}
                            name={col.visible ? 'AijBasicYulan' : 'AijBasicYincang'}
                            size={16}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <Popover
            content={panelContent}
            trigger="click"
            placement="bottom"
            open={open}
            onOpenChange={handleOpenChange}
            getPopupContainer={getPopupContainer}
            classNames={{root: styles.popoverRoot}}
        >
            <Button
                type="default"
                size="mini"
                className={`${styles.trigger}${open ? ` ${styles.triggerActive}` : ''}`}
                style={{padding: '6px 6px 6px 8px'}}
                icon={
                    <Icon className={styles.triggerIcon} name="AijBasicZhanshishezhi" size={14} />
                }
            >
                <span className={styles.triggerText}>展示设置</span>
                <Icon
                    className={styles.triggerArrow}
                    name="AijBasicXiala"
                    size={14}
                    style={
                        open
                            ? {transform: 'rotate(180deg)', transition: 'transform 0.2s'}
                            : {transition: 'transform 0.2s'}
                    }
                />
            </Button>
        </Popover>
    );
};

export default ColumnSettings;
